import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Injector } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import {LocationStrategy, HashLocationStrategy} from '@angular/common';

//  App Init
import { routing, appRoutingProviders } from './app.routing';

//  Components
import { AppComponent } from './app.component';
import { StandardComponent } from './components/standard/standard.component';
import { SplashComponent } from './components/splash/splash.component';
import { SignInComponent } from './components/signin/signin.component';
import { SignUpComponent } from './components/signup/signup.component';
import { RestoreComponent } from './components/signup/restore.component';
import { AbstractComponent } from './components/abstract/abstract.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ViewAbstractComponent } from './components/abstract/viewAbstract.component';
import { ViewReviewersComponent } from './components/reviewer/viewReviewers.component';
import { CreateReviewComponent } from './components/review/createReview.component';

//  Services
import { AbstractService } from './services/abstract.service';
import { AuthenticationService } from './services/authentication.service';
import { RegistrationService } from './services/registration.service';
import { HttpService } from './services/http.service';
import { ReviewerService } from './services/reviewer.service';
import { StorageService } from './services/storage.service';
import { LookupService } from './services/lookup.service';
import { UtilityService } from './services/utility.service';
import { ReviewService } from './services/review.service';
import { ServiceFinder } from './services/finder.service';

//  Pipes
import { SearchPipe } from './pipes/searchPipe';
import { OrderByPipe } from './pipes/orderByPipe';

//  Libraries
import { ModalModule } from 'angular2-modal';
import { BootstrapModalModule } from 'angular2-modal/plugins/bootstrap';
import { SimpleNotificationsModule } from 'angular2-notifications';


@NgModule({
  declarations: [
    AppComponent,
    StandardComponent,
    SplashComponent,
    SignInComponent,
    SignUpComponent,
    RestoreComponent,
    AbstractComponent,
    DashboardComponent,
    ViewAbstractComponent,
    ViewReviewersComponent,
    CreateReviewComponent,
    SearchPipe,
    OrderByPipe
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    routing,
    ModalModule.forRoot(),
    BootstrapModalModule,
    SimpleNotificationsModule
  ],
  providers: [
    appRoutingProviders,
    AbstractService,
    AuthenticationService,
    RegistrationService,
    HttpService,
    StorageService,
    LookupService,
    UtilityService,
    ReviewerService,
    ReviewService,
    ServiceFinder,
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    }
  ],
  entryComponents: [
    ViewAbstractComponent,
    ViewReviewersComponent,
    CreateReviewComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { 
  constructor(private injector: Injector) {
    ServiceFinder.injector = injector;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts